import { indexItems } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/70 border border-primary-200/60 text-primary-700 text-xs font-semibold mb-4 whitespace-nowrap">
            <i className="ri-apps-line text-sm"></i>
            分区索引
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">内容分区索引</h2>
          <p className="text-sm text-foreground-500 max-w-2xl mx-auto">按领域分类浏览，快速找到你感兴趣的吃瓜内容。</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#index"
              className="group flex items-center gap-4 p-4 md:p-5 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200/70 transition-colors duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 rounded-lg bg-accent-100/80 flex items-center justify-center flex-shrink-0 group-hover:bg-accent-200 transition-colors duration-300">
                <i className={`${item.icon} text-xl text-accent-600`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-base font-bold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">{item.title}</h3>
                <p className="text-xs text-foreground-500 mt-0.5">{item.desc}</p>
              </div>
              <span className="flex-shrink-0 text-xs text-foreground-400 bg-background-100 px-2 py-1 rounded whitespace-nowrap">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}